export interface AccountAuthConfig {
  apiBaseUrl: string;
  handoffUrl: string;
  legacyLoginUrl: string;
  registerUrl: string;
  forgotPasswordUrl: string;
  development: boolean;
}

export function loadAccountAuthConfig(env: ImportMetaEnv = import.meta.env): AccountAuthConfig {
  const legacyLoginUrl = cleanUrl(env.VITE_ACCOUNT_LEGACY_LOGIN_URL, '/?legacy_auth=1');
  return Object.freeze({
    apiBaseUrl: cleanApiBaseUrl(env.VITE_ACCOUNT_API_BASE_URL),
    handoffUrl: cleanUrl(env.VITE_ACCOUNT_HANDOFF_URL, '/conferencing/meetings/'),
    legacyLoginUrl,
    registerUrl: cleanUrl(env.VITE_ACCOUNT_REGISTER_URL, withQuery(legacyLoginUrl, 'register', 'yes')),
    forgotPasswordUrl: cleanUrl(
      env.VITE_ACCOUNT_FORGOT_PASSWORD_URL,
      withQuery(legacyLoginUrl, 'forgot_password', 'yes'),
    ),
    development: Boolean(env.DEV),
  });
}

function cleanApiBaseUrl(value: string | undefined): string {
  const clean = String(value || '').trim().replace(/\/+$/, '');
  if (!clean) return '';
  try {
    const parsed = new URL(clean);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.toString().replace(/\/+$/, '');
  } catch {
    // The error below is intentionally stable and contains no secret values.
  }
  throw new Error('VITE_ACCOUNT_API_BASE_URL must be an HTTP(S) origin');
}

function cleanUrl(value: string | undefined, fallback: string): string {
  return String(value || '').trim() || fallback;
}

function withQuery(url: string, key: string, value: string): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
}
